import * as configAPI from '~api/config';

let config = undefined;

// Load the configuration from the API
export const loadConfig = async () => {
  try {
    const { data } = await configAPI.getConfig();
    config = data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to load config:', error);
    config = {};
  }
};

export default function getConfig() {
  return config;
}

export const getLucidAuthAPIBaseURL = () => config['LUCID_AUTH_API_BASE_URL'];
export const getLucidServerAPIBaseURL = () => config['LUCID_SERVER_API_BASE_URL'];
export const getEnvironment = () => config['ENVIRONMENT'];
export const getDatadogURL = () => config['DATADOG_URL'];

